import TooltipInfo from '@/components/TooltipInfo';
import { useEffect, useRef, useState } from 'react';
import { Box, styled } from '@mui/material';

type Props = {
  text?: string;
  children?: React.ReactNode;
  styles?: React.CSSProperties;
  lineCount: number;
};

export const LineClamp = (props: Props) => {
  const [overflow, setOverflow] = useState(false);
  const contentRef = useRef<HTMLDivElement>();

  const childrenToRender = props.children ?? props.text;

  useEffect(() => {
    if (contentRef.current) {
      //+2 to consider the borders
      if (contentRef.current.scrollHeight > contentRef.current.clientHeight + 2) {
        setOverflow(true);
      }
    }
  }, []);

  const content = (
    <LineClampDiv ref={contentRef} style={{ ...(props.styles || {}) }} $lineCount={props.lineCount}>
      {childrenToRender}
    </LineClampDiv>
  );

  if (overflow) {
    return (
      <TooltipInfo onHover text={props.text} placement='top' onHoverCursor='unset'>
        {content}
      </TooltipInfo>
    );
  } else {
    return content;
  }
};

export const LineClampDiv = styled(Box, {
  shouldForwardProp: prop => prop !== '$lineCount',
})(({ $lineCount }: { $lineCount: number }) => ({
  display: '-webkit-box',
  boxOrient: 'vertical',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineClamp: $lineCount.toString(),
  '-webkit-line-clamp': $lineCount.toString(),
  whiteSpace: 'pre-wrap',
  wordBreak: $lineCount === 1 ? 'break-all' : 'break-word',
}));
